// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"cd228eb1","149":"6c398cac","214":"a7539c48","319":"0ee612bd","453":"a3b51781","949":"10b3b21b"}[chunkId] + ".chunk.js";
};